import React, { useState } from "react";
import styles from "./Footer.module.scss";
import Card1 from "../../../../images/card1.png";
import Card2 from "../../../../images/card2.png";
import Button from "components/UI/Button/Button";
import { Link, useNavigate } from "react-router-dom";
import YoutubeSVG from "components/SVGComponents/YoutubeSVG";
import FacebookSVG from "components/SVGComponents/FacebookSVG";
import TwitterSVG from "components/SVGComponents/TwitterSVG";
import InstagramSVG from "components/SVGComponents/InstagramSVG";
import LinkedlnSVG from "components/SVGComponents/LinkedlnSVG";
import CreativesLogoSVG from "components/SVGComponents/CreativesLogoSVG";
import Modal from "components/Modal/Modal";
import CommunityGuideline from "components/CommunityGuidelines/CommunityGuideline";
import TermsConditions from "components/termsConditions/TermsConditions";

const socialIcons = [
  {
    icon: <YoutubeSVG />,
    // href: "/signin",
  },
  {
    icon: <FacebookSVG />,
    href: "https://www.facebook.com/share/1B2jHt7J6h/?mibextid=wwXIfr",
  },
  {
    icon: <TwitterSVG />,
    href: "https://x.com/qreativs?s=21",
  },
  {
    icon: <InstagramSVG />,
    href: "https://www.instagram.com/qreativs?igsh=Nzh2bjl4ZTAybXh6",
  },
  {
    icon: <LinkedlnSVG />,
    href: "https://www.linkedin.com/company/qreativs/",
  },
];

const Footer = ({ communityGuidelines = false, terms = false }) => {
  const [termsModal, setTermsModal] = useState(terms);
  const [guideLineModal, setGuideLineModal] = useState(communityGuidelines);
  const navigate = useNavigate();

  return (
    <>
      <section className={styles.footerTop}>
        <img src={Card1} alt="Card1" />
        <div className={styles.content}>
          <h2 className="title">
            Join the creative pool.
            <br />
            Join Qreativs
          </h2>
          <p>Find projects, businesses and creatives around you.</p>
          <Button
            onClick={() => navigate("/signup")}
            className={styles.btn}
            variant="filled"
          >
            Sign Up Now
          </Button>
        </div>
        <img src={Card2} alt="Card2" />
      </section>
      <footer>
        <CreativesLogoSVG width="125" height="35" />
        <div className={styles.credits}>
          <span>Qreativs @2025</span>
          <div>
            <ul>
              <li onClick={() => setTermsModal((prev) => !prev)}>
                <Link to="/terms-conditions">Terms & Privacy Policy</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact</Link>
              </li>
              <li onClick={() => setGuideLineModal((prev) => !prev)}>
                <Link to="/community-guidelines">Community guidelines</Link>
              </li>
            </ul>
            <ul>
              {socialIcons.map((social, id) => (
                <li key={id} >
                  <a href={social.href} target="_blank">{social.icon}</a>
                </li>
              ))}
            </ul>
          </div>
          <Modal
            // width="40rem"
            onClose={(e) => {
              // e.stopPropagation()
              setGuideLineModal(false);
            }}
            heading="Community guidelines"
            modalOpen={guideLineModal}
            showCrossIcon={true}
          >
            <CommunityGuideline />
          </Modal>
          <Modal
            // width="40rem"
            onClose={(e) => {
              // e.stopPropagation()
              setTermsModal(false);
            }}
            heading="Terms & Conditions"
            modalOpen={termsModal}
            showCrossIcon={true}
          >
            <TermsConditions />
          </Modal>
        </div>
      </footer>
    </>
  );
};

export default Footer;
